// Propósito: persistencia de sesión OAuth en storage y señales.
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { StorageService } from '@services/core/storage.service';

/** Guarda el refresh token en memoria y storage. */
function storeRefresh(auth: MicrosoftAuthService, storage: StorageService, token: string): void {
  auth.refreshToken.set(token);
  storage.setJsonValue('refresh_token', token);
}

/** Guarda los tokens de la sesión. */
function storeSessionTokens(auth: MicrosoftAuthService, storage: StorageService, res: any): void {
  storage.setJsonValue('logged', 'true');
  storage.setJsonValue('token', res.access_token);
  storeRefresh(auth, storage, res.refresh_token);
}

/** Persiste la sesión y marca logueado. */
export function persistSessionState(auth: MicrosoftAuthService, storage: StorageService, res: any): void {
  auth.token.set(res.access_token);
  storeSessionTokens(auth, storage, res);
  auth.isLoggedSignal.set(true);
}
